import moment from "moment";
import {
  SET_STANDPLAATSEN,
  ADD_STANDPLAATSEN,
  GET_ACCOMMODATIES,
  APPEND_ACCOMMODATIES,
  SET_ACCOMMODATIE,
  ADD_ACCOMMODATIE,
  SET_KAMPEERPLAATS,
  SET_KAMPEERPLAATSEN,
  APPEND_KAMPEERPLAATSEN,
  SET_STANDPLAATS,
  STANDPLAATS_ERROR,
  SET_SOORT_SESNSOREN,
  SET_SENSOR_DAG,
  SET_SENSOR_UUR,
  SET_SENSOR_MAAND,
  SET_CATEGORIEN,
  SET_CATEGORIE,
  SET_PERIODE,
  SET_RELAIS,
  GET_REAILS,
  GET_VELDKASTEN,
  SET_VELDKASTEN,
  SET_OFFLINE_KAMPEERPLAATSEN,
} from "./actions";
export default function standplaatsen(
  state = {
    relaiss: [],
    relais: {},
    item: [],
    items: [],
    sensoren: [],
    kampeerplaatsen: [],
    offlineKampeerplaatsen: [],
    accommodaties: [],
    accommodatie: {},
    kampeerplaats: {},
    error: {},
    uur: [],
    maand: [],
    dag: [],
    categorien: [],
    categorie: {},
    veldkasten: [],
    veldkast: {},
    periode: {
      startdate: moment().subtract(1, "months").toDate(),
      enddate: moment().toDate(),
    },
  },
  action = {}
) {
  switch (action.type) {
    case ADD_STANDPLAATSEN:
      return { ...state, items: [...state.items, action.results] };
    case SET_STANDPLAATS:
      return { ...state, item: action.results };
    case SET_KAMPEERPLAATSEN:
      return { ...state, kampeerplaatsen: action.results };
    case APPEND_KAMPEERPLAATSEN:
      return { ...state, kampeerplaatsen: [...state.kampeerplaatsen, ...action.results] };
    case SET_OFFLINE_KAMPEERPLAATSEN:
      return { ...state, offlineKampeerplaatsen: action.results };
    case SET_KAMPEERPLAATS:
      return { ...state, kampeerplaats: action.results };
    case SET_STANDPLAATSEN:
      return { ...state, items: action.results };
    case SET_CATEGORIEN:
      return { ...state, categorien: action.results };
    case SET_CATEGORIE:
      return { ...state, categorie: action.results };
    case SET_SOORT_SESNSOREN:
      return { ...state, sensoren: action.results };
    case SET_SENSOR_UUR:
      return { ...state, uur: action.results };
    case SET_SENSOR_DAG:
      return { ...state, dag: action.results };
    case SET_SENSOR_MAAND:
      return { ...state, maand: action.results };
    case STANDPLAATS_ERROR:
      return { ...state, error: action.payload };
    case GET_ACCOMMODATIES:
      return { ...state, accommodaties: action.results };
    case APPEND_ACCOMMODATIES:
      return { ...state, accommodaties: [...state.accommodaties, ...action.results] };
    case ADD_ACCOMMODATIE:
      return { ...state, accommodaties: [...state.accommodaties, action.results] };
    case SET_ACCOMMODATIE:
      return { ...state, accommodatie: action.results };
    case SET_PERIODE:
      return { ...state, periode: action.results };
    case GET_REAILS:
      return { ...state, relaiss: action.results };
    case SET_RELAIS:
      return { ...state, relais: action.results };
    case GET_VELDKASTEN:
      return { ...state, veldkasten: action.results };
    case SET_VELDKASTEN:
      return { ...state, veldkast: action.results };
    default:
      return state;
  }
}
